<template>
  <v-container class="pa-0">
    <v-skeleton-loader
      class="mx-auto"
      type="image, list-item-three-line"
      v-if="!isLoaded"
    ></v-skeleton-loader>

    <v-container v-if="isLoaded" class="header gray--text text-center">
      <v-avatar color="white" size="128">
        <v-img :src="profile.image" alt=""></v-img>
      </v-avatar>
      <h4 class="pt-3">{{ profile.name }}</h4>
      <h5 class="font-weight-regular">Happenstance</h5>
    </v-container>
    <v-container v-if="isLoaded" class="pa-5">
      <v-row class="pt-2 pb-2" no-gutters>
        <v-col cols="4" class="text-left subtitle-2 font-weight-light"
          >EMP Code :</v-col
        >
        <v-col cols="8" class="text-right subtitle-2 font-weight-regular">{{
          profile.code
        }}</v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row class="pt-2 pb-2" no-gutters>
        <v-col cols="4" class="text-left subtitle-2 font-weight-light"
          >Phone :</v-col
        >
        <v-col cols="8" class="text-right subtitle-2 font-weight-regular">{{
          profile.mobile
        }}</v-col>
      </v-row>

      <v-divider></v-divider>
      <v-row class="pt-2 pb-2" no-gutters>
        <v-col cols="4" class="text-left subtitle-2 font-weight-light"
          >Email :</v-col
        >
        <v-col cols="8" class="text-right subtitle-2 font-weight-regular">{{
          profile.email
        }}</v-col>
      </v-row>

      <v-divider></v-divider>
      <v-row class="pt-2 pb-2" no-gutters>
        <v-col cols="4" class="text-left subtitle-2 font-weight-light"
          >DOJ :</v-col
        >
        <v-col cols="8" class="text-right subtitle-2 font-weight-regular">
          {{ moment(profile.created_at).format("MMM DD, YYYY") }}
        </v-col>
      </v-row>
      <v-divider></v-divider>
    </v-container>
    <v-snackbar v-model="snackbar" color="error" timeout="2500"
      >{{ snackbar_message }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      snackbar: false,
      snackbar_message: "Internal Server Error",
      isLoaded: false,
      profile: {},
    };
  },
  created() {
    this.$api.getProfile().then(
      (response) => {
        if (response.data.status == "success") {
          this.profile = response.data.employee;
          this.isLoaded = true;
        } else {
          console.log("failed to load profile");
        }
      },
      (error) => {
        console.log(error);
        this.isLoaded = true;
        this.isLoading = false;
        this.snackbar = true;
      }
    );
  },
};
</script>
<style lang="scss" scoped>
.header {
  background: #eee;
}
</style>
